import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	companyId: null,
};

const companyStore = (set: any) => ({
	...initialState,
	setCompanyId: (data: number | null) => set((state: any) => ({ ...state, companyId: data })),
	resetState: () => set({ ...initialState }),
});

const useCompanyStore = create(devtools(companyStore));

export const { setCompanyId, resetState } = useCompanyStore.getState();

export default useCompanyStore;
